var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":""}},[_c('v-app',[_c('v-main',[_c('UserNavbar'),_c('AuthenticationCallback')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }